<template>
  <page :basic="true">
    <span slot="header">Starred Topics</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
    </span>
    <topics-table :view="view"/>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import topicsTable from '../topics/table'
import page from '../../../templates/page'

export default {
  components: {
    topicsTable,
    page
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Modules',
        to: { name: 'client-modules' }
      },
      {
        text: 'Starred Topics',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('topics', {
      view: '_favoritesView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/starred-topics/index.vue